"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InsightsTarget_1 = __importDefault(require("./targets/InsightsTarget"));
const GoogleAnalyticsTarget_1 = __importDefault(require("./targets/GoogleAnalyticsTarget"));
const IpexMomentEnum_1 = __importDefault(require("./enums/IpexMomentEnum"));
const GaEventEnum_1 = __importDefault(require("./enums/GaEventEnum"));
const GaCategoryEnum_1 = __importDefault(require("./enums/GaCategoryEnum"));
const DesignSourceEnum_1 = __importDefault(require("./enums/DesignSourceEnum"));
const SessionManager_1 = __importDefault(require("./utilities/SessionManager"));
const DesignInteractionEnum_1 = __importDefault(require("./enums/DesignInteractionEnum"));
const TrackingIdEnum_1 = __importDefault(require("./enums/TrackingIdEnum"));
const ArticleActionEnum_1 = __importDefault(require("./enums/ArticleActionEnum"));
const InsightsEventEnum_1 = __importDefault(require("./enums/InsightsEventEnum"));
const MetadataManager_1 = __importDefault(require("./utilities/MetadataManager"));
const FlowHandler_1 = __importDefault(require("./utilities/FlowHandler"));
/**
 * Class for sending of events to various sources.
 */
class EventSender {
    constructor() {
        this.insights = new InsightsTarget_1.default();
        this.sessionManager = new SessionManager_1.default();
        this.googleAnalytics = new GoogleAnalyticsTarget_1.default();
        this.flowHandler = new FlowHandler_1.default();
    }
    /**
     * Set the module id in insights target.
     *
     * @param moduleId The module id.
     */
    setTargetModuleId(moduleId) {
        this.insights.moduleId = moduleId;
    }
    /**
     * Set up Google Analytics, and send open_planner events to Insights and GA.
     *
     * @param props Properties for the init event.
     * @returns The promise for setupGoogleAnalytics.
     */
    setupAndSendInit(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendApplicationStartUpEvents();
            return this.googleAnalytics
                .setupGoogleAnalytics({
                countryCode: props.countryCode.toLowerCase(),
                language: props.languageCode.toLowerCase(),
                plannerName: props.applicationId,
                dev: !!props.dev,
                platform: props.platform
            })
                .then(() => __awaiter(this, void 0, void 0, function* () {
                const session = this.sessionManager.getValidId(TrackingIdEnum_1.default.sessionIdKey);
                this.googleAnalytics.sendGoogleAnalyticsEvent(GaCategoryEnum_1.default.planners, GaEventEnum_1.default.openPlanner, session.id);
            }));
        });
    }
    /**
     * Send an add_to_cart event to Insights and GA.
     *
     * @param data Items added to cart.
     */
    sendAddToCart(data) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            const planning = this.sessionManager.getId(TrackingIdEnum_1.default.planningIdKey);
            const session = this.sessionManager.getId(TrackingIdEnum_1.default.sessionIdKey);
            yield Promise.all([
                this.insights.sendInsightsEvent(IpexMomentEnum_1.default.giveMe, InsightsEventEnum_1.default.addToCart, {
                    currency: data.currency,
                    ['design_id']: data.designId ? data.designId : null,
                    articles: data.items,
                    ['unavailable_articles']: data.unavailableItems ? data.unavailableItems : null
                }, data.payload),
                this.googleAnalytics.sendGoogleAnalyticsEventWithParams(GaEventEnum_1.default.addToCart, {
                    currency: data.currency,
                    items: data.items.map(item => ({
                        id: item.id,
                        price: item.price,
                        quantity: item.qty
                    }))
                }, {
                    // This is custom dimension 47 and will be renamed to planner_product_combination_id on the server side
                    // Note that this is not the planning id, but rather the design id due to a legacy naming on Ingkas side.
                    ['planning_id']: (_a = data.designId) !== null && _a !== void 0 ? _a : null,
                    // Relevant primarily for episod, we include session and the actual planning id that relates to sessions.
                    ['session_id']: (_b = session === null || session === void 0 ? void 0 : session.id) !== null && _b !== void 0 ? _b : null,
                    ['session_planning_id']: (_c = planning === null || planning === void 0 ? void 0 : planning.id) !== null && _c !== void 0 ? _c : null
                })
            ]);
        });
    }
    /**
     * Send an add_to_wishlist event to Insights and GA.
     *
     * @param data Items added to wish list.
     */
    sendAddToWishList(data) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            const planning = this.sessionManager.getId(TrackingIdEnum_1.default.planningIdKey);
            const session = this.sessionManager.getId(TrackingIdEnum_1.default.sessionIdKey);
            yield Promise.all([
                this.insights.sendInsightsEvent(IpexMomentEnum_1.default.giveMe, InsightsEventEnum_1.default.addToWishList, {
                    currency: data.currency,
                    ['design_id']: (_a = data.designId) !== null && _a !== void 0 ? _a : null,
                    articles: data.items
                }, data.payload),
                this.googleAnalytics.sendGoogleAnalyticsEvent(GaCategoryEnum_1.default.ecommerce, GaEventEnum_1.default.addToWishlist, undefined, {
                    // Custom dimension 47
                    ['planning_id']: (_b = data.designId) !== null && _b !== void 0 ? _b : null,
                    // Relevant primarily for episod, we include session and the actual planning id that relates to sessions.
                    ['session_id']: (_c = session === null || session === void 0 ? void 0 : session.id) !== null && _c !== void 0 ? _c : null,
                    ['session_planning_id']: (_d = planning === null || planning === void 0 ? void 0 : planning.id) !== null && _d !== void 0 ? _d : null
                })
            ]);
        });
    }
    /**
     *
     * @param designId The design id that started the planning session.
     * @param source The source of the planning session.
     * @param payload The payload data.
     * @param spr The SPR that was used as base for the planning if any.
     * @throws If source does not exist in DesignSourceEnum.
     */
    sendInitPlanningSession(designId, source, payload, spr) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Object.values(DesignSourceEnum_1.default).includes(source)) {
                throw Error(`Failed to send event, design source ${source} is not a valid source. Check DesignSourceEnum.`);
            }
            this.updateDesignId(designId, source);
            this.sessionManager.createId(TrackingIdEnum_1.default.planningIdKey, source, designId, spr);
            yield this.updateLocalIds();
            // Planning data is sent automatically when the event is created.
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, InsightsEventEnum_1.default.initiatePlanningSession, undefined, payload);
        });
    }
    /**
     * Send a save_planner event to Insights and GA.
     *
     * @param designId The design id to save.
     * @param payload The payload data.
     * @param mode How this design was saved or shared.
     */
    sendSavePlanner(designId, payload, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            const metadata = MetadataManager_1.default.getApplicationMetadata();
            yield this.updateLocalIds();
            yield Promise.all([
                this.insights.sendInsightsEvent(IpexMomentEnum_1.default.giveMe, 'save_planner', {
                    ['mode']: mode,
                    ['design_id']: designId
                }, payload),
                this.googleAnalytics.sendGoogleAnalyticsEvent(GaCategoryEnum_1.default.planners, GaEventEnum_1.default.savePlanner, metadata.applicationId, {
                    // Custom dimension 47
                    ['planning_id']: designId
                })
            ]);
        });
    }
    /**
     * Send a custom event to Insights. The name of the event is contained in data.event.
     *
     * @param data Data sent with the event.
     */
    sendCustomEvent(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(data.ipexMoment, data.event, undefined, data.payload);
        });
    }
    /**
     * Send a design interaction event to Insights.
     *
     * @param designId The design id which was interacted with.
     * @param interaction The interaction source.
     * @param payload The payload data.
     * @throws An Error if interaction is incorrect.
     */
    sendDesignInteractionEvent(designId, interaction, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Object.values(DesignInteractionEnum_1.default).includes(interaction)) {
                throw Error(`Failed to send event, interaction ${interaction} is not a valid interaction. Check DesignInteractionEnum.`);
            }
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, interaction, {
                ['design_id']: designId
            }, payload);
        });
    }
    /**
     * Send an article_action event to Insights.
     *
     * @param articleId The article id.
     * @param action The action being performed.
     * @param isGlobal Indicate if article id is global or local.
     * @param [payload] Optional payload data.
     * @throws An Error if action is incorrect.
     */
    sendArticleAction(articleId, action, isGlobal, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Object.values(ArticleActionEnum_1.default).includes(action)) {
                throw Error(`Failed to send event, action ${action} is not a valid interaction. Check ArticleActionEnum.`);
            }
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.makeItMe, InsightsEventEnum_1.default.articleAction, {
                ['article_action']: action,
                ['article_id']: articleId,
                ['is_global']: isGlobal
            }, payload);
        });
    }
    /**
     * Send a flow step event to Insights.
     *
     * @param flowName Name of the flow.
     * @param stepName Name of the step in the flow.
     * @param stepLevel Level of step in the flow.
     */
    sendUserFlowStep(flowName, stepName, stepLevel, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            let previousStepName;
            let previousStepLevel;
            const flow = this.flowHandler.getFlow(flowName);
            if (flow === undefined) {
                this.flowHandler.createFlow(flowName, stepName, stepLevel);
                previousStepName = null;
                previousStepLevel = null;
            }
            else {
                previousStepLevel = flow.stepLevel;
                previousStepName = flow.stepName;
                this.flowHandler.updateFlow(flowName, stepName, stepLevel);
            }
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, InsightsEventEnum_1.default.userFlow, {
                ['flow_name']: flowName,
                ['step_name']: stepName,
                ['step_level']: stepLevel,
                ['previous_step_name']: previousStepName,
                ['previous_step_level']: previousStepLevel
            }, payload);
        });
    }
    /**
     * Send mandatory startup event for the module client flow.
     */
    sendModuleStartUpEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, 'connect_module');
        });
    }
    /**
     * Send mandatory startup event for the application startup flow.
     */
    sendApplicationStartUpEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, InsightsEventEnum_1.default.connectApplication);
        });
    }
    /**
     * Send AB version changed event.
     */
    sendSetAbVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateLocalIds();
            yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, 'set_ab_version');
        });
    }
    /**
     * Register a design id in the metadata, or throw an Error if it's empty/undefined and source is incorrect.
     * If the design id is empty/undefined and the source is start_from_scratch, start_from_template,
     * resume_last_design, or space design id will be registered as start_from_scratch, start_from_template,
     * resume_last_design, or space respectively. Should a design id be provided, that will be registered instead.
     *
     * @param designId The design id to update.
     * @param source The source of the planning session.
     */
    updateDesignId(designId, source) {
        if (!designId &&
            source !== DesignSourceEnum_1.default.startFromScratch &&
            source !== DesignSourceEnum_1.default.startFromTemplate &&
            source !== DesignSourceEnum_1.default.resumeLastDesign &&
            source !== DesignSourceEnum_1.default.space) {
            // Will throw an error if no design id is provided (or it's empty), given source is not start_from_scratch
            throw Error('No design id provided');
        }
        else if (!designId && source === DesignSourceEnum_1.default.startFromScratch) {
            MetadataManager_1.default.updateApplication({ designId: 'start_from_scratch' });
        }
        else if (!designId && source === DesignSourceEnum_1.default.startFromTemplate) {
            MetadataManager_1.default.updateApplication({ designId: 'start_from_template' });
        }
        else if (!designId && source === DesignSourceEnum_1.default.resumeLastDesign) {
            MetadataManager_1.default.updateApplication({ designId: 'resume_last_design' });
        }
        else if (!designId && source === DesignSourceEnum_1.default.space) {
            MetadataManager_1.default.updateApplication({ designId: 'space' });
        }
        else {
            MetadataManager_1.default.updateApplication({ designId });
        }
    }
    /**
     * Update all local Ids through the session manager, then sends a start event if a new Id was generated.
     */
    updateLocalIds() {
        return __awaiter(this, void 0, void 0, function* () {
            const eventData = this.sessionManager.updateIds();
            if (eventData !== undefined) {
                yield this.insights.sendInsightsEvent(IpexMomentEnum_1.default.nonInteraction, InsightsEventEnum_1.default.start, eventData);
            }
        });
    }
}
exports.default = EventSender;
//# sourceMappingURL=EventSender.js.map